import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePrevious } from "@sportal/cdk/hooks";

export const useOnRouteChange = <F extends () => void>(action: F) => {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  useEffect(() => {
    if (prevLocation?.pathname !== location.pathname) {
      action();
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps
};
